import * as React from 'react';
import PropTypes from 'prop-types';
import { printInHourDisplayFormat } from '../../libs/dateTimePrinting';
import FormatSettingsContext from '../../components/FormatSettingsContext';
import {
  TimesheetUnavailabilitiesCard,
  TimesheetUnavailabilityTitle,
  TimesheetUnavailabilityItemCardInfo
} from './TimesheetUnavailabilities.style';
import YPTimesheetUnavailabilityObject from '../../yesplan_classes/YPTimesheetUnavailabilityObject';
import { Body } from '../../styled components/Typography';

function TimesheetUnavailabilities({ unavailabilities }) {
  const renderTimes = function (uObj) {
    const { timeFormatSetting } = React.useContext(FormatSettingsContext);
    const startTimeString = printInHourDisplayFormat(
      uObj.getPlannedStart(),
      timeFormatSetting
    );
    const endTimeString = printInHourDisplayFormat(
      uObj.getPlannedEnd(),
      timeFormatSetting
    );

    return (
      <Body tw="text-red-base" data-test-timesheet-unavailability-times>
        {`${startTimeString}–${endTimeString}`}
      </Body>
    );
  };

  const renderUnavailability = function (uObj) {
    return (
      <TimesheetUnavailabilityItemCardInfo
        key={uObj.getId()}
        data-test-timesheet-unavailability
      >
        <TimesheetUnavailabilityTitle>{uObj.getTitle()}</TimesheetUnavailabilityTitle>
        {renderTimes(uObj)}
      </TimesheetUnavailabilityItemCardInfo>
    );
  };

  return (
    <TimesheetUnavailabilitiesCard>
      {unavailabilities.map((uObj) => renderUnavailability(uObj))}
    </TimesheetUnavailabilitiesCard>
  );
}

TimesheetUnavailabilities.propTypes = {
  unavailabilities: PropTypes.arrayOf(
    PropTypes.instanceOf(YPTimesheetUnavailabilityObject)
  ).isRequired
};

export default TimesheetUnavailabilities;
